var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", [
    _c(
      "div",
      [
        _c("section", { staticClass: "image-bg2", attrs: { id: "content" } }, [
          _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-sm-8 col-md-9", attrs: { id: "main" } },
                [
                  _c("sdr-shared-flightsearch-tabs", {
                    attrs: { modulo: "booking" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "sidebar col-sm-4 col-md-3" },
                [
                  _c("sdr-covid19-box"),
                  _vm._v(" "),
                  _c("sdr-contact-box"),
                  _vm._v(" "),
                  _c("sdr-importantinfos3-box"),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("sdr-keydestinations", { attrs: { modulo: "booking" } }),
        _vm._v(" "),
        _c("sdr-shared-flightsearchresults", { attrs: { modulo: "booking" } }),
        _vm._v(" "),
        _c("sdr-furtherserives"),
        _vm._v(" "),
        _c("sdr-promobox-sundair-app"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }